
module.exports = {
    Base_URL:process.env.REACT_APP_API_URL    
}